export const FETCH_STUDENT_START = 'FETCH_CHILD_START';
export const FETCH_STUDENT_FAIL = 'FETCH_CHILD_FAIL';
export const FETCH_STUDENT_SUCCESS = 'FETCH_CHILD_SUCCESS';
export const FETCH_PARENT_SUCCESS = 'FETCH_PARENT_SUCCESS';
